import { render, staticRenderFns } from "./CustomerInfoEdit.vue?vue&type=template&id=552807a3&scoped=true&"
import script from "./CustomerInfoEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoEdit.vue?vue&type=style&index=0&id=552807a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552807a3",
  null
  
)

export default component.exports